import { Injectable } from '@angular/core';

import { ConfigParserService } from '../../shared/services/config-parser.service';

export interface EncryptionConfig {
    readonly cryptoKey: JsonWebKey;
    readonly digestSaltBase64: string;
}

@Injectable({
    providedIn: 'root'
})
export class EncryptionConfigService {
    public readonly config: EncryptionConfig;

    constructor(
        private readonly configParserService: ConfigParserService
    ) {
        this.config = this.configParserService.parse('serviceWorkerEncryptionConfig') || {
            cryptoKey: null,
            digestSaltBase64: null
        };
    }
}
